import React from "react"
import usePosts from "../hooks/use-posts"
// import { Link } from "gatsby"
import { css } from "styled-components"
import Layout from "../layouts/layout"
import PostPreview from "../layouts/post-preview"
// import Image from "../components/image";
import SEO from "../components/seo"
import { Button, UiText, Heading } from "../components"
import Projects from "../components/Projects"
import { Link } from "gatsby"
const IndexPage = () => {
  const posts = usePosts()
  return (
    <>
      <Layout>
        <SEO title="Home" />
        <div
          css={css`
            position: relative;
            max-width: 960px;
            margin: auto;
            padding: 40px 0px;
          `}
        >
          <article className="first-entry home-info">
            <header className="entry-header">
              <Heading variant="h1" as="h1" level={1}>
                Hardware Engineer | RTL, FPGA, SoC, and RF/Analog IC Design
              </Heading>
              <UiText variant="subContent" as="p">
                Senior software engineer at a test-and-measurement company by
                day, building RTL and silicon the rest of the time.
              </UiText>
            </header>
            <section className="entry-content">
              <UiText variant="content">
                Hi, I am Souleymane Dembele, a computer/hardware engineer in the
                Greater Seattle Area. I design across the stack: transistor-level
                RF/analog ICs, RTL and FPGA accelerators, computer architecture,
                and embedded firmware with custom RTOS work. My current focus is a
                custom GEMM accelerator on a Cyclone V SoC, the subject of my MS
                ECE thesis at the University of Washington Tacoma. The projects
                and write-ups below cover the hardware I build.
              </UiText>
            </section>
            <footer>
              <Link to="/about">
                <Button
                  css={css`
                    padding: 8px 16px;
                    margin: 0;
                  `}
                >
                  <UiText as="span" margin="0px" variant="subContentBold">
                    Learn more
                  </UiText>
                </Button>
              </Link>
            </footer>
          </article>
          <div>
            <Heading as="h2" variant="h2" level={2}>
              Selected Projects
            </Heading>
            <Projects limit={5} />
          </div>
          <div>
            <Heading as="h2" variant="h2" level={2}>
              Latest Blog
            </Heading>
            {posts.slice(0, 5).map(post => (
              <PostPreview key={post.slug} post={post} />
            ))}
            <Link to="/blog">
              <Button
                css={css`
                  margin: 1rem 0 0;
                  padding: 8px 16px;
                `}
              >
                <UiText as="span" margin="0px" variant="subContentBold">
                  View all posts
                </UiText>
              </Button>
            </Link>
          </div>
        </div>
      </Layout>
    </>
  )
}

export default IndexPage
// I am a software engineer that focuses on front-end tools such as react, react native, and electron. I have a passion for design systems, Serverless technology

// I am a Software Engineer that focuses on front-end tools such as react, angular, and react-native. I have a passion for design systems, web accessibility, serverless technologies such as AWS and Google Cloud, and Artificial Intelligence. To grow my skills, I focus on building JAM (Javascript API Markup) stack applications.
